export default __webpack_public_path__ + "static/media/uman10.9fa482e7.png";